import React, { useState } from 'react';
import CircularProgressChart from './CircularProgressChart';

function AttemptCard({ attempt, index, attemptNumber, isSelected }) {
  const [isHovered, setIsHovered] = useState(false);

  // Check if score is a number or "About to play"
  const isPlayMode = typeof attempt.score !== 'number' || isNaN(attempt.score);

  // Calculate stars based on score percentage
  const getStarsCount = (score) => {
    // If score is not a number ("About to play"), return 0 stars
    if (typeof score !== 'number' || isNaN(score)) return 0;
    
    if (score >= 80) return 5;
    if (score >= 60) return 4;
    if (score >= 40) return 3;
    if (score >= 20) return 2;
    return 1;
  };

  const starsCount = getStarsCount(attempt.score);
  
  // Dynamic styles that can't be done with Tailwind classes
  const getBorderHoverStyle = () => {
    if (isSelected) {
      return "border-blue-600 shadow-blue-200";
    } else if (isPlayMode) {
      return "hover:border-gray-400 hover:shadow-gray-200";
    } else if (attempt.score > 75) {
      return "hover:border-green-400 hover:shadow-green-200";
    } else if (attempt.score > 40) {
      return "hover:border-blue-400 hover:shadow-blue-200";
    } else {
      return "hover:border-red-400 hover:shadow-red-200";
    }
  };

  return (
    <div 
      className={`bg-white rounded-lg sm:rounded-xl p-2 sm:p-3 lg:p-4 shadow w-full sm:w-36 md:w-40 lg:w-44 text-center 
        transform transition-all duration-300 ease-out
        border-2 ${isSelected ? 'border-blue-600' : 'border-transparent'} ${getBorderHoverStyle()}
        ${isSelected ? 'shadow-md shadow-blue-100' : 'hover:shadow-md'} backdrop-blur-md
        ${isHovered ? 'scale-105 -translate-y-1' : 'scale-100 translate-y-0'}
        ${index === 0 ? 'border-l-4 border-blue-500' : ''}
        ${index === 1 ? 'border-l-4 border-green-500' : ''}
        ${index === 2 ? 'border-l-4 border-purple-500' : ''}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        perspective: '1000px',
        transformStyle: 'preserve-3d'
      }}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center justify-center w-full">
          <span className="text-md text-black font-semibold text-center">Assessment {attemptNumber}</span>
        </div>
        {isSelected && (
          <div className="bg-blue-600 w-2 h-2 rounded-full"></div>
        )}
      </div>
      
      <CircularProgressChart 
        score={attempt.score} 
        index={index} 
        session={attempt.attemptNumber} 
        key={`chart-${attempt.assessmentNumber}-${attempt.id}-${attempt.attemptNumber}`} 
      />
      
      <div className="text-base sm:text-lg transition-all duration-300 mt-2">
        {isPlayMode ? (
          // For "About to play" mode, show all empty stars
          [...Array(5)].map((_, i) => (
            <span
              key={i}
              className="inline-block text-gray-300"
            >
              ☆
            </span>
          ))
        ) : (
          // For normal scores, show filled/empty stars based on score
          [...Array(5)].map((_, i) => (
            <span
              key={i}
              className={`inline-block ${i < starsCount ? 'text-yellow-400' : 'text-gray-300'}`}
            >
              {i < starsCount ? '★' : '☆'}
            </span>
          ))
        )}
      </div>
    </div>
  );
}

export default AttemptCard;